import { render, staticRenderFns } from "./infomanager.vue?vue&type=template&id=10a9dedb&scoped=true"
import script from "./infomanager.vue?vue&type=script&lang=js"
export * from "./infomanager.vue?vue&type=script&lang=js"
import style0 from "./infomanager.vue?vue&type=style&index=0&id=10a9dedb&prod&scoped=true&lang=css"
import style1 from "./infomanager.vue?vue&type=style&index=1&id=10a9dedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9dedb",
  null
  
)

export default component.exports